// tslint:disable: prettier
import { FieldType } from '../config';
import { IDescriptionProps } from '../Description';
import { numberToPrettyString, plural } from '@cian/utils';
import { getFormattedQuarter } from '../../../utils/formatters';
import { getBuildMaterialTypeText } from '../../../utils/build_material_type_text';
import { getLandStatusText } from '../../../utils/land_status_text';
import { getLandAreaUnitTypeText } from '../../../utils/land_area_unit_type_text';
import { TMaterialType, TLandStatus, TAreaUnitType } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getCommercialArea } from '../../../utils/offer_helpers';
import { NBSP } from '../../../constants';

export const getInfoValue = (config: FieldType, props: IDescriptionProps) => {
  const {
    deadline,
    floorNumber,
    floorsCount,
    buildMaterialType,
    landStatus,
    landArea,
    landAreaUnitType,
    availableData,
    possibleToChangeStatus,
    minArea,
    maxArea,
    totalArea,
  } = props;

  const propertyValue = props[config.name];

  switch (true) {
    case config.type === 'area':
      const value = Number(propertyValue);

      return value && !isNaN(value) ? `${numberToPrettyString(value)}${NBSP}м²` : '';

    case config.type === 'deadline':
      return deadline && deadline.year && deadline.quarter
        ? `${getFormattedQuarter(deadline.quarter)} ${deadline.year}`
        : deadline && deadline.year;

    case config.type === 'floorNumber' && !!floorNumber:
      return floorsCount ? `${floorNumber} из ${floorsCount}` : floorNumber;

    case config.type === 'buildMaterialType' && !!buildMaterialType:
      return getBuildMaterialTypeText(buildMaterialType as TMaterialType);

    case config.type === 'landStatus' && !!landStatus:
      return getLandStatusText(landStatus as TLandStatus);

    case config.type === 'landArea' && !!landArea && !!landAreaUnitType:
      const landAreaValue = Number(landArea);

      return landAreaValue && !isNaN(landAreaValue)
        ? `${landAreaValue} ${getLandAreaUnitTypeText(landAreaUnitType as TAreaUnitType)}`
        : '';

    case config.type === 'occupied':
      return !!propertyValue ? (availableData ? `Занято до ${availableData}` : 'Занято') : 'Свободно';

    case config.type === 'commercialFloorsCount':
      return `${propertyValue} ${plural(Number(propertyValue), ['этаж', 'этажа', 'этажей'])}`;

    case config.type === 'ceilingHeight' && !!propertyValue:
      return `${numberToPrettyString(Number(propertyValue))}${NBSP}м`;

    case config.type === 'commercialLandType' && !!propertyValue:
      return `${propertyValue}${possibleToChangeStatus ? ' (можно изменить)' : ''}`;

    case config.type === 'commercialArea':
      return getCommercialArea(minArea, maxArea, totalArea);

    case config.name === 'minLeaseTerm':
      return propertyValue ? `От ${propertyValue} мес.` : '';

    case config.type === 'classType':
    default:
      return propertyValue;
  }
};
